import none from '../none.js';

// TODO Should this be optimized into one condition without need to compute both results?
// - Implementation is now based on specification definition.
// - Optimized implementation would need to be specific for each fit function used.
// - Unit test would be nice to check all the combinations.
/**
 * Child is sized as `none` or fit function,
 * whichever would result in a smaller size.
 * This only works for fit functions that keep the aspect ratio, because specification doesn't says
 * how to compare them (is rectangle 2x1 bigger than 1x2?).
 * @param {object} parent
 * @param {object} child
 * @param {Function} fit
 * @returns {object}
 */
const scaleDown = (parent, child, fit) => {
  const fitResult = fit(parent, child);
  // Because the fit function keeps the aspect ratio, only the width can be checked.
  // Because the none function keeps the image size, child width can be used instead.
  if (fitResult.width > child.width) {
    return none(parent, child);
  }
  return fitResult;
};

export default scaleDown;
